import view from './view.html';

/* @ngInject */
export default function () {
	return {
		restrict:                   'E',
		template:                   view,
		replace:                    true,
		controller: /* @ngInject */ ($scope, AuthService, PermissionsUsers, toastr, $timeout, $state) => {
			$scope.AuthService = AuthService;

			$scope.selected = {
				user: null,
			};

			if (!AuthService.isImpersonating()) {
				$scope.users = null;

				PermissionsUsers.getList({
					                include: 'workable',
				                })
				                .then((users) => {
					                $scope.users = users;
				                });
			}

			$scope.startImpersonating = () => {
				if ($scope.selected.user) {
					toastr.clear();
					toastr.success('You are now impersonating a user.', 'Impersonating User');

					AuthService.impersonateUser($scope.selected.user)
					           .then(() => {
						           return AuthService.refreshUser();
					           })
					           .then(() => {
						           $state.go('splash.home');
					           });
				} else {
					toastr.clear();
					toastr.error('You must select a user to impersonate.', 'Error');
				}
			};

			$scope.stopImpersonating = () => {
				toastr.clear();
				toastr.success('You are no longer impersonating any users.', 'No Longer Impersonating User');

				AuthService.impersonateUser(null)
				           .then(() => {
					           return AuthService.refreshUser();
				           })
				           .then(() => {
					           $state.go('splash.home');
				           });
			};
		},
	};
};


// WEBPACK FOOTER //
// ./src/js/directives/impersonateUser/index.js